'use client';

import { useContext } from 'react';
import { TokenGateContext } from '~/app/context/TokenGateContext';

export default function useTokenGate() {
  return useContext(TokenGateContext);
}
